import React, { useState, useEffect } from "react";

const TopSplitSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    gap: isMobile ? "20px" : "30px",
    padding: isMobile ? "40px 20px" : "60px 20px",
    flexWrap: isMobile ? "wrap" : "nowrap",
  };

  const boxBaseStyle = {
    width: isMobile ? "100%" : "48%",
    padding: isMobile ? "30px 20px" : "50px 40px",
    backgroundColor: "#007bff",
    color: "#fff",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    textAlign: "left",
  };

  const leftBoxStyle = {
    ...boxBaseStyle,
    borderTopLeftRadius: isMobile ? "20px" : "40px",
    borderTopRightRadius: isMobile ? "20px" : "0px",
  };

  const rightBoxStyle = {
    ...boxBaseStyle,
    borderTopRightRadius: isMobile ? "20px" : "40px",
    borderTopLeftRadius: isMobile ? "20px" : "0px",
  };

  const headlineStyle = {
    fontSize: isMobile ? "24px" : "32px",
    marginBottom: isMobile ? "15px" : "25px",
    fontWeight: "700",
    lineHeight: "1.3",
  };

  const listStyle = {
    fontSize: isMobile ? "15px" : "17px",
    lineHeight: "1.8",
    margin: 0,
    paddingLeft: "20px",
    listStyleType: "disc",
  };

  const listItemStyle = {
    marginBottom: "10px",
  };

  const yellowText = {
    color: "#ffc107",
  };

  return (
    <div style={containerStyle}>
      <div style={leftBoxStyle}>
        <h2 style={headlineStyle}>
          Lifetime <span style={yellowText}>Support</span>
        </h2>
        <ul style={listStyle}>
          <li style={listItemStyle}>
            Your journey won’t end with the course — JK Associates provides lifetime expert support and access.
          </li>
          <li style={listItemStyle}>
            Your growth continues long after the course — JK Associates offers lifetime access and dedicated expert support.
          </li>
          <li style={listItemStyle}>
            At JK Associates, learning never ends — enjoy lifetime access and expert guidance beyond the course.
          </li>
        </ul>
      </div>
      <div style={rightBoxStyle}>
        <h2 style={headlineStyle}>
          Learning & <span style={yellowText}>Earning</span>
        </h2>
        <ul style={listStyle}>
          <li style={listItemStyle}>
            At JK Associates, we empower you to Learn, Earn, and grow from beginner to professional — your path to financial independence starts here.
          </li>
          <li style={listItemStyle}>
            Learn with confidence, earn with skill — JK Associates is your trusted partner from beginner to professional.
          </li>
          <li style={listItemStyle}>
            Our courses empower you to Learn and Earn — from beginner to professional. JK Associates guides your journey to financial independence.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TopSplitSection;
